<div class="modal-body">
  <qai-field
    [label]="(isKnowledgeCheck() ? 'simulationBuilder.KNOWLEDGE_CHECK_NAME_LABEL' : 'simulationBuilder.SIMULATION_NAME_LABEL') | transloco"
    [description]="'simulationBuilder.NAME_FIELD_DESCRIPTION' | transloco"
    [error]="errorMessage"
  >
    <input
      qai-input
      type="text"
      [(ngModel)]="inputName"
      [disabled]="isAmendDocumentsMode()"
      (input)="onInputChange()"
    />
  </qai-field>

  <qai-field
    [label]="'simulationBuilder.PRODUCT_LABEL' | transloco"
    class="product-field"
  >
    <qai-floating-select
      [options]="moduleOptions"
      [placeholder]="'simulationBuilder.SELECT_A_PRODUCT_PLACEHOLDER' | transloco"
      [placement]="'below-start'"
      [offset]="4"
      [shape]="'rectangle'"
      [value]="selectedModuleUuid"
      [searchable]="true"
      [showActionButton]="true"
      [actionButtonLabel]="'simulationBuilder.ADD_NEW_PRODUCT' | transloco"
      [disabled]="networkRequestInProgress() || isLoadingModuleOptions || isAmendDocumentsMode()"
      (action)="onAddNewProduct($event)"
      (selectionChange)="onModuleSelectionChange($event?.value)"
    ></qai-floating-select>
  </qai-field>

  @if (isSelfAuthoring()) {
    <qai-field
      [label]="'simulationBuilder.TAGS_LABEL' | transloco"
      [error]="tagError"
      class="tags-field"
      [class.is-disabled]="networkRequestInProgress() || isAmendDocumentsMode()"
    >
      <qai-multiselect
        #tagsSelect
        [options]="tagOptions"
        [value]="selectedTagUuids"
        [placeholder]="''"
        [persistSearch]="true"
        [disabled]="networkRequestInProgress() || isAmendDocumentsMode()"
        (valueChange)="onTagsChange($event)"
        (searchChange)="tagError = undefined"
      >
        <ng-template #dropdownHeader let-term>
          @if (canCreateTag(term)) {
            <button
              qai-menuitem
              type="button"
              [label]="'simulationBuilder.CREATE_TAG_OPTION' | transloco: { term: term.trim() }"
              [disabled]="isCreatingTag"
              (click)="onCreateTag(term)"
            >
              <qai-icon kind="plus" positionStart />
            </button>
          }
        </ng-template>
      </qai-multiselect>
    </qai-field>

    @if (!isKnowledgeCheck()) {
      <qai-field
        [label]="'simulationBuilder.SCENARIO_LABEL' | transloco"
        class="scenario-field"
      >
        <textarea
          qai-textarea
          autosize
          [maxLines]="5"
          [(ngModel)]="scenario"
          [disabled]="isAmendDocumentsMode()"
        ></textarea>
      </qai-field>
    }

    <qai-field
      [label]="'simulationBuilder.REFERENCE_DOCUMENTS_LABEL' | transloco"
      class="reference-documents-field"
    >
      <qai-file-upload
        [isMultipleMode]="true"
        [acceptedFileTypes]="'.pdf'"
        [maxCombinedSizeInMB]="50"
        [maxFiles]="5"
        [disabled]="isAnyDocumentUploading()"
        [fileStatuses]="fileStatuses()"
        [error]="fileUploadError"
        [selectedFiles]="uploadedFiles"
        (selectedFilesChange)="onFilesSelected($event)"
        (fileRemoveRequested)="onFileRemoveRequested($event)"
      >
        <div class="upload-content">
          <p class="upload-title">
            <span class="upload-link">{{ 'simulationBuilder.CLICK_TO_UPLOAD' | transloco }}</span>
            <span class="upload-text"> {{ 'simulationBuilder.OR_DRAG_AND_DROP' | transloco }}</span>
          </p>
          <p class="upload-description">
            {{ 'simulationBuilder.REFERENCE_DOCUMENTS_UPLOAD_DESCRIPTION' | transloco }}
          </p>
        </div>
      </qai-file-upload>
    </qai-field>

    @if (showDocumentDependentFields()) {
      <qai-field
        [label]="'simulationBuilder.KC_INSTRUCTIONS_LABEL' | transloco"
        class="scenario-field"
      >
        <textarea
          qai-textarea
          autosize
          [maxLines]="5"
          [(ngModel)]="scenario"
        ></textarea>
      </qai-field>

      <!-- Not a qai-field: it switches to its inline checkbox layout and moves the label after the options. -->
      <div class="generation-options-field" role="group" aria-labelledby="generation-options-label">
        <span id="generation-options-label" class="generation-options-label">
          {{ 'simulationBuilder.ADDITIONAL_GENERATION_OPTIONS_LABEL' | transloco }}
        </span>
        <div class="generation-options">
          <div class="generation-option">
            <label class="checkbox-label">
              <input
                qai-checkbox
                type="checkbox"
                class="generate-hints-checkbox"
                [(ngModel)]="generateHints"
              />
              <span>{{ 'simulationBuilder.GENERATE_HINTS_LABEL' | transloco }}</span>
            </label>
            <button
              #hintsHelpRef
              qai-icon-button
              type="button"
              class="hints-help-button"
              [icon]="'help-circle'"
              [kind]="'tertiary'"
            >
              {{ 'simulationBuilder.HINTS_TOOLTIP_TITLE' | transloco }}
            </button>
            <qai-tooltip
              [qaiFloating]="hintsHelpRef.el.nativeElement"
              [placement]="'above-center'"
              [events]="['click']"
              [style.maxWidth]="'320px'"
            >
              <div class="tooltip-heading">{{ 'simulationBuilder.HINTS_TOOLTIP_TITLE' | transloco }}</div>
              {{ 'simulationBuilder.KNOWLEDGE_CHECK_QUESTION_HINT_TOOLTIP' | transloco }}
            </qai-tooltip>
          </div>

          <div class="generation-option">
            <label class="checkbox-label">
              <input
                qai-checkbox
                type="checkbox"
                class="generate-resource-notes-checkbox"
                [(ngModel)]="generateResourceNotes"
              />
              <span>{{ 'simulationBuilder.GENERATE_RESOURCE_NOTES_LABEL' | transloco }}</span>
            </label>
            <button
              #resourceNotesHelpRef
              qai-icon-button
              type="button"
              class="resource-notes-help-button"
              [icon]="'help-circle'"
              [kind]="'tertiary'"
            >
              {{ 'simulationBuilder.RESOURCE_NOTES_TOOLTIP_TITLE' | transloco }}
            </button>
            <qai-tooltip
              [qaiFloating]="resourceNotesHelpRef.el.nativeElement"
              [placement]="'above-center'"
              [events]="['click']"
              [style.maxWidth]="'320px'"
            >
              <div class="tooltip-heading">{{ 'simulationBuilder.RESOURCE_NOTES_TOOLTIP_TITLE' | transloco }}</div>
              {{ 'simulationBuilder.KNOWLEDGE_CHECK_QUESTION_RESOURCE_TOOLTIP' | transloco }}
            </qai-tooltip>
          </div>
        </div>
      </div>
    }
  }
</div>

<div class="action-button-container">
  <button
    qai-button
    size="medium"
    kind="primary"
    [disabled]="isConfirmDisabled()"
    (click)="handleConfirmClick()"
  >
    {{ confirmButtonLabel() }}
  </button>
</div>
